export default "__VITE_ASSET__BtmPOUUJ__"